import "../assets/styles/MainPage.css";
import dcLogo from '../assets/img/logo.svg';
import { useState} from "react";
import TenantList from "../components/TenantList";

export default function MainPage({ children, headerContent }) {
    return (
        <div className="main-layout">
            <header className="header">
                <div className="header-left">
                    <img src={dcLogo} alt="dc Logo" className="logo-image-small" />
                    <span className="title">dc Tracking</span>
                </div>
                <div className="header-right">
                    {headerContent}
                </div>
            </header>
            <div className="body">
                <main className="content">
                    {children}
                </main>
            </div>
        </div>
    );
}